import { SQL, type SQLFragment } from '@/client/query'

export function getExperimentArm(
  _userId: number,
  _usecase?: 'training' | null
): 'control' | 'experiment' {
  return 'control'
}

export function getExperimentArmQuery(_userId: number | SQLFragment<number>): SQLFragment<string> {
  return SQL`'control'`
}
